// Generated by CoffeeScript 2.7.0
var MembersTable;

import DataTableMixin from 'trunks/vue/admin/compositions/datable_table/mixin.js';

import DeleteUserConfirmPopover from 'trunks/vue/admin/components/users/delete_user_confirm_popover.js';

import ResponseCreateMemberModal from 'trunks/vue/admin/compositions/organizations/responses/create_member_modal.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import tableSpecialFields from 'trunks/vue/admin/compositions/datable_table/table_special_fields.js';

export default MembersTable = Vue.extend({
  mixins: [DataTableMixin],
  components: {
    'delete-user-confirm-popover': DeleteUserConfirmPopover
  },
  props: {
    resourceUrl: {
      type: String,
      required: true
    },
    organization: {
      type: Object
    },
    deleteMemberOperation: {
      type: Boolean,
      default: true
    },
    speacialFields: {
      type: Array
    }
  },
  data: function() {
    return {
      headers: [],
      fixedColumnIds: [-14],
      initialSelectedTagIds: [],
      selectedRows: [],
      profileSchema: null
    };
  },
  template: `<div class="datable-table-wrapper">
  <slot name="datable-table-summary" :selectedRows='selectedRows'></slot>
  <div class="filter-summary justify-box" v-if='filtersExist && organization'>
    <span>筛选条件</span>
    <div class="params chips content">
      <filter-chip v-for='(filter, key) in filters'
                   :key='key'
                   :filter='filter'
                   @remove='removeFilter' />
    </div>
  </div>
  <v-table :headers='filterFields'
           :rows='recordRows'
           :fixedColumnIds='fixedColumnIds'
           :enableOperation="true"
           @rowClicked='openEditUserModal'
           @selectedRowsChanged='selectedRowsChangedFunc'
           ref='bodyTable'>
    <template slot='header' slot-scope='{ header }'>
      <header-cell :field='header'
                   :enableColumnFilter='organization ? header._has_search : false'
                   :hasSort='!header._has_search'
                   @orderChanged='removeOrUpdateOrder'
                   @filterChanged='removeOrUpdateFilter' />
    </template>
    <template slot='body' slot-scope='{ cell }'>
      <field-cell :field='cell.field'
                  :entries='cell.entries'
                  @unbindUser='updateRecordAfterUnbindFunc'></field-cell>
    </template>
    <template slot='operation-cell' slot-scope='{ row }' v-if='deleteMemberOperation'>
      <delete-user-confirm-popover :row='row'
                                   :organization='organization'
                                   @deleteMemberSuccessed='refreshData' />
    </template>
  </v-table>
  <paginator :resourceUrl='doRequestUrl'
             :additionalParams='paginatorParams'
             :beforeRequestFunc='beforeRecordsRequestFunc'
             :afterRequestFunc='afterRecordsRequestFunc'
             @dataReceived='updateRecords'
             @afterGo='resetTableAllSelected'
             ref='paginator' />
</div>`,
  created: function() {
    return this._getUserProfileSchema();
  },
  computed: {
    doRequestUrl: function() {
      // 表示在组织成员的列表才有搜索
      if (this.filtersExist && this.organization) {
        return `${this.resourceUrl}/search`;
      } else {
        return this.resourceUrl;
      }
    },
    profileSchemaFieldIds: function() {
      var ref;
      if ((ref = this.profileSchema) != null ? ref.fields : void 0) {
        return _.map(this.profileSchema.fields, function(field) {
          return field.id;
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    selectedRowsChangedFunc: function(selectedRows) {
      return this.selectedRows = selectedRows;
    },
    openEditUserModal: function(event, row, child) {
      var response;
      if (!row.id) {
        return;
      }
      this.$refs.bodyTable.focusOnRow(row);
      response = this._generateResponse(row);
      return this.responseEditMemberModal = new ResponseCreateMemberModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('response_create_member_modal_container'),
        propsData: {
          title: '编辑成员',
          tagsRequestUrl: "/tag_groups/user",
          initialSelectedTagIds: this.initialSelectedTagIds,
          profileSchema: this.profileSchema,
          response: response,
          record: row.record,
          createUserCallback: (data) => {
            return this.editUsersRequestFunc(row.id, data);
          }
        }
      });
    },
    editUsersRequestFunc: function(id, data) {
      return Skylark.Libs.Ajax.patch(`/admin/users/${id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: data,
        success: () => {
          newAlertify('修改成功', {
            type: 'success'
          });
          this.responseEditMemberModal.cancel();
          return this.refreshData();
        },
        error: function(xhr, status, data) {
          var error_message;
          error_message = _.map(data, function(value, key) {
            return `${Skylark.Helpers.getZH_CN('message.' + key)}${value[0]}`;
          });
          return newAlertify('修改失败', {
            type: 'error',
            description: error_message.join(',')
          });
        }
      });
    },
    resetTableAllSelected: function() {
      return this.$refs.bodyTable.resetAllSelected();
    },
    updateRecordAfterUnbindFunc: function(user_id) {
      var unbind_record;
      unbind_record = _.find(this.records, function(record) {
        return record.id === user_id;
      });
      unbind_record.openid = null;
      return this.updateRecord(unbind_record);
    },
    refreshSeletedRowsTags: function(updateTagsOptions) {
      return _.each(this.selectedRows, (row) => {
        var record;
        if (row.id) {
          record = row.record;
          record.tags = this._parseRecordTags(record, updateTagsOptions);
          return this.updateRecord(record);
        }
      });
    },
    _parseRecordTags: function(record, updateTagsOptions) {
      var array, tags;
      array = _.reduce(updateTagsOptions.selectedOptionTags, function(memo, selected_tag) {
        if (!_.some(record.tags, function(record_tag) {
          return record_tag.id === selected_tag.id;
        })) {
          memo.push(selected_tag);
        }
        return memo;
      }, record.tags);
      tags = _.reduce(array, function(memo, tag) {
        if (!_.some(updateTagsOptions.deletedOptionTags, function(deleted_tag) {
          return deleted_tag.id === tag.id;
        })) {
          memo.push(tag);
        }
        return memo;
      }, []);
      return tags;
    },
    _generateResponse: function(row) {
      var entries, response;
      entries = _.reduce(row.children[0].cells, (memo, cell) => {
        var ref, ref1, ref2, ref3, ref4, ref5;
        switch (cell.cell_id) {
          case -16:
            this.initialSelectedTagIds = [];
            _.each(cell.entries, (item) => {
              return this.initialSelectedTagIds.push(item.value.tag_id);
            });
            break;
          case -1:
            memo.push({
              field_id: (ref = cell.entries[0]) != null ? ref.field_id : void 0,
              value: (ref1 = cell.entries[0]) != null ? ref1.value.name : void 0
            }, {
              field_id: -2,
              value: (ref2 = cell.entries[0]) != null ? ref2.value.nickname : void 0
            }, {
              field_id: -3,
              value: (ref3 = cell.entries[0]) != null ? ref3.value.identifier : void 0
            });
            break;
          default:
            if (!_.contains(this.profileSchemaFieldIds, cell.field.id)) {
              memo.push({
                field_id: (ref4 = cell.entries[0]) != null ? ref4.field_id : void 0,
                value: (ref5 = cell.entries[0]) != null ? ref5.value : void 0
              });
            }
        }
        return memo;
      }, []);
      response = new Skylark.App.Model.Response({
        id: row.id,
        entries: entries
      });
      return response;
    },
    _addSpecialFields: function(receivier, hidden_ids) {
      var speacialFields;
      speacialFields = this.speacialFields ? this.speacialFields : tableSpecialFields.members_table_special_fields;
      _.each(receivier, function(field) {
        return field._has_search = false;
      });
      if (speacialFields[0].id === -1) {
        speacialFields = speacialFields.reverse();
      }
      return _.each(speacialFields, function(field) {
        return receivier.unshift(field);
      });
    },
    __parseSpecialCells: function(field, record, grouped_entries, rowspan, receivier) {
      if (!record.id) {
        return;
      }
      switch (field.id) {
        case -1:
          return receivier.entries = [
            {
              field_id: -1,
              value: {
                id: record.id,
                name: record.name,
                nickname: record.nickname,
                headimgurl: record.headimgurl,
                from_wechat: record.from_wechat,
                identifier: record.identifier,
                openid: record.openid
              }
            }
          ];
        case -4:
          return receivier.entries = [
            {
              field_id: -4,
              value: record.phone
            }
          ];
        case -16:
          return receivier.entries = _.map(record.tags, function(tag) {
            return {
              field_id: -16,
              value: {
                name: tag.name,
                tag_id: tag.id
              }
            };
          });
        case -17:
          return receivier.entries = [
            {
              field_id: -17,
              value: record.organizations
            }
          ];
        default:
          if (_.contains(this.profileSchemaFieldIds, field.id)) {
            return this.__parseProfileCells(field, record, grouped_entries, rowspan, receivier);
          } else {
            return this.__parseNormalCells(field, record, grouped_entries, rowspan, receivier);
          }
      }
    },
    __parseProfileCells: function(field, record, grouped_entries, rowspan, receivier) {
      var ref;
      return receivier.entries = [
        {
          field_id: field.id,
          value: this._getEntries(field.id,
        (ref = record.profile_submission) != null ? ref.entries : void 0)
        }
      ];
    },
    _getEntries: function(id, entries) {
      if (entries) {
        return _.chain(entries).filter(function(entry) {
          return entry.field_id === id;
        }).map(function(item) {
          return item.value;
        }).value();
      } else {
        return [];
      }
    },
    _formatRecords: function(records) {
      return records;
    },
    _getUserProfileSchema: function() {
      return Skylark.Libs.Ajax.get("/admin/user_profile/schema.json", {
        responseType: 'json',
        success: (profileSchema) => {
          return this.profileSchema = new Skylark.App.Model.UserProfile.Schema(profileSchema);
        }
      });
    }
  }
});
